import React from 'react'
import FormatCurrency from '../elements/FormatCurrency'
import DynamicColor from '../common/dynamic-color'
import DynamicAction from '../common/dynamic-action'
import GroupAmountSmall from '../elements/group-amount-small'

import { ensureArray } from '../../utils/helper'
import { COLOR_NAME } from '../../constants'
import { getDisplayFoodName } from '../../utils'

const FoodSubmited = ({ food }) => {
    const { price, amount, note, additionFoods } = food

    // map list id topping to get full info for show
    // let toppingShow = reMapBeilage(item)

    return (
        <DynamicColor
            style={{ borderColor: COLOR_NAME.BODY_LINE }}
            className="food-item-submitted"
        >
            <DynamicAction className="food-item-added">
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="food-item-added__main"
                >
                    <div className="food-info">
                        <div className="food-info--name">
                            {getDisplayFoodName(food)}
                        </div>

                        <GroupAmountSmall amount={amount} viewOnly />

                        <div className="price">
                            <div>
                                <FormatCurrency amount={price} />
                            </div>
                        </div>
                    </div>
                    {(!!note || !!additionFoods?.length) && (
                        <div className="list-topping">
                            <div className="list-topping__item label-3">
                                <div>{note}</div>
                                <div />
                            </div>

                            {ensureArray(additionFoods).map((el, i) => (
                                <DynamicColor
                                    style={{ color: COLOR_NAME.BODY_TEXT_SUB }}
                                    key={i}
                                    className="list-topping__item label-3"
                                >
                                    <div>{el.name}</div>
                                </DynamicColor>
                            ))}
                        </div>
                    )}
                </DynamicColor>
            </DynamicAction>
        </DynamicColor>
    )
}

export default FoodSubmited
